import { LandscapeImageCard } from '@bnnvara/cards';
import truncate from 'lodash/truncate';
import PropTypes from 'prop-types';
import React from 'react';

import resizeImageSource from '../../../helpers/resizeImageSource';
import truncateTitle from '../../../helpers/truncateTitle';
import Link from '../../Link';

const PersonItemCard = ({
  name,
  photo,
  description,
  subtitle,
  slug,
  firstCharacter,
}) => {
  const firstCharacterLowerCase = firstCharacter.toLowerCase();
  const background = photo
    ? resizeImageSource(photo.url, 450)
    : '/static/fallbackImages/videofallback.jpg';
  const truncatedDescription =
    description &&
    truncate(description, {
      length: 140,
    });

  return (
    <Link href={`personen/${firstCharacterLowerCase}/${slug}`}>
      <LandscapeImageCard
        title={name ? truncateTitle(name) : ''}
        thumbnail={background}
        description={truncatedDescription}
        subtitle={subtitle}
      />
    </Link>
  );
};

PersonItemCard.defaultProps = {
  photo: null,
  subtitle: null,
  slug: null,
  firstCharacter: null,
};

PersonItemCard.propTypes = {
  photo: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  slug: PropTypes.string,
  firstCharacter: PropTypes.string,
};

export default PersonItemCard;
